import {
  polygonAmoy,
  spicy,
  polygon,
  gnosis,
  chiliz,
  base,
  baseSepolia,
} from 'viem/chains'

const isDevEnabled = process.env.NEXT_PUBLIC_NODE_ENV === 'development'

export const appChains = isDevEnabled
  ? ([polygon, polygonAmoy, gnosis, chiliz, spicy, base, baseSepolia] as const)
  : ([polygon, base, gnosis, chiliz] as const)
